import React, { useState, useEffect } from "react";
//Redux
import { useDispatch, useSelector } from "react-redux";
import {
  loadFormValue,
} from "../../../../actions/formDataActions";

const InputPhone = ({ defaultValue }) => {
  //Store data
  const { formValues } = useSelector((state) => state.dataForm);

  //States
  const [displayError, setDisplayError] = useState(false);

  //Redux actions
  const dispatch = useDispatch();
  const storeLoadFormValue = (valuePair) => dispatch(loadFormValue(valuePair));

  //Functions
  const loadInputValue = (e) => {
    storeLoadFormValue(["phone", e.target.value]);
  };

  //useEffect
  useEffect(() => {
    //Check field validation
    if (formValues && formValues.phone && formValues.phone !== "") {
      setDisplayError(false);
    } else {
      setDisplayError(true);
    }
    // eslint-disable-next-line
  }, [formValues.phone]);

  useEffect(() => {
    //In case of update, load current value into form values
    if (defaultValue) {
      storeLoadFormValue(["phone", defaultValue]);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="input-container col-4">
      <div className="input-label">Teléfono</div>
      <input
        type="text"
        name="phone"
        placeholder="Escriba el teléfono *"
        className={(displayError === true ? " errorInput " : "")}
        onChange={loadInputValue}
        defaultValue={defaultValue ? defaultValue : ""}
      />
    </div>
  );
};

export default InputPhone;
